module.exports = __webpack_public_path__ + "static/media/warning.4da5c0f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warning.png
// module id = 182
// module chunks = 1